{
  "primer": {
    "eyebrow": "مواقيت الصلاة والقبلة",
    "headline": "يحتاج Rhemn إلى موقعك لمواقيت الصلاة والقبلة.",
    "body": "نستخدمه لمواقيت صلاتك واتجاه القبلة والطقس المحلي — لا شيء غير ذلك.",
    "cta": "متابعة",
    "skip": "ليس الآن",
    "skip_body": "ستبقى مواقيت الصلاة والقبلة متوقفة."
  }
}
